import type { MorphemeHrefObject } from "@-/dev.improve.haniverse.lib.morpheme.href.entities";
import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { MorphemeInlineNavigationContext } from "#morpheme-inline-navigation-context";
import { useCallback, useContext } from "react";
import { useMorphemePanelsPageNavigatorOptions } from "#use-morpheme-panels-page-navigator-options";

function useNavigator() {
  const inlineNavigate = useContext(MorphemeInlineNavigationContext);
  const getMorphemePanelsPageNavigatorOptions = useMorphemePanelsPageNavigatorOptions();

  return useCallback(
    ({ morpheme, prefix }: { morpheme: string; prefix: MorphemeHrefObject }) => ({
      ...getMorphemePanelsPageNavigatorOptions({ morpheme, prefix }),
      navigate: inlineNavigate === null ? undefined : () => inlineNavigate({ morpheme, prefix }),
    }),
    [getMorphemePanelsPageNavigatorOptions, inlineNavigate],
  );
}

export const useMorphemePanelsHrefNavigator = createPageNavigator({
  useNavigator,
});
